import { render } from "./Carousel.vue?vue&type=template&id=010822a5&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=010822a5&scoped=true&lang=css"

import exportComponent from "D:\\Developpement\\HATPLC\\frontend 25122025\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010822a5"]])

export default __exports__